import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import z from 'zod';
var HEX_COLOR_REGEX = new RegExp(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/);
function isValidHexColor(value) {
  return HEX_COLOR_REGEX.test(value);
}
var colorStr = z.string().refine(isValidHexColor);
var gradientArr = z.tuple([z.string(), z.string()]).refine(function (value) {
  return isValidHexColor(value[0]) && isValidHexColor(value[1]);
});
export var SemanticColorsSchema = z.object({
  actionInactive: colorStr,
  actionInverted: colorStr,
  actionPrimary: colorStr,
  actionPrimaryHover: colorStr,
  actionPrimaryPressed: colorStr,
  actionSecondary: colorStr,
  actionSecondaryHover: colorStr,
  actionSecondaryPressed: colorStr,
  actionPositive: colorStr,
  actionPositiveHover: colorStr,
  actionPositivePressed: colorStr,
  actionWarning: colorStr,
  actionWarningHover: colorStr,
  actionWarningPressed: colorStr,
  actionNegative: colorStr,
  actionNegativeHover: colorStr,
  actionNegativePressed: colorStr,
  actionMagic: colorStr,
  actionMagicHover: colorStr,
  actionMagicPressed: colorStr,
  bgRegular: colorStr,
  bgRegularHover: colorStr,
  bgRegularPressed: colorStr,
  bgInactive: colorStr,
  bgPrimary: colorStr,
  bgPrimaryHover: colorStr,
  bgPrimaryPressed: colorStr,
  bgPrimaryHighlight: colorStr,
  bgPrimaryHighlightHover: colorStr,
  bgPrimaryHighlightPressed: colorStr,
  bgSecondary: colorStr,
  bgSecondaryHover: colorStr,
  bgSecondaryPressed: colorStr,
  bgSecondaryHighlight: colorStr,
  bgSecondaryHighlightHover: colorStr,
  bgSecondaryHighlightPressed: colorStr,
  bgMagic: colorStr,
  bgMagicHover: colorStr,
  bgMagicPressed: colorStr,
  bgMagicHighlight: colorStr,
  bgMagicHighlightHover: colorStr,
  bgMagicHighlightPressed: colorStr,
  bgWarning: colorStr,
  bgWarningHover: colorStr,
  bgWarningPressed: colorStr,
  bgWarningHighlight: colorStr,
  bgWarningHighlightHover: colorStr,
  bgWarningHighlightPressed: colorStr,
  bgPositive: colorStr,
  bgPositiveHover: colorStr,
  bgPositivePressed: colorStr,
  bgPositiveHighlight: colorStr,
  bgPositiveHighlightHover: colorStr,
  bgPositiveHighlightPressed: colorStr,
  bgNegative: colorStr,
  bgNegativeHover: colorStr,
  bgNegativePressed: colorStr,
  bgNegativeHighlight: colorStr,
  bgNegativeHighlightHover: colorStr,
  bgNegativeHighlightPressed: colorStr,
  borderInactive: colorStr,
  borderInverted: colorStr,
  borderRegular: colorStr,
  borderRegularHover: colorStr,
  borderRegularPressed: colorStr,
  borderPrimary: colorStr,
  borderPrimaryHover: colorStr,
  borderPrimaryPressed: colorStr,
  borderSecondary: colorStr,
  borderSecondaryHover: colorStr,
  borderSecondaryPressed: colorStr,
  borderPositive: colorStr,
  borderPositiveHover: colorStr,
  borderPositivePressed: colorStr,
  borderWarning: colorStr,
  borderWarningHover: colorStr,
  borderWarningPressed: colorStr,
  borderNegative: colorStr,
  borderNegativeHover: colorStr,
  borderNegativePressed: colorStr,
  borderMagic: colorStr,
  borderMagicHover: colorStr,
  borderMagicPressed: colorStr,
  cardSelected: colorStr,
  iconInactive: colorStr,
  iconOnAction: colorStr,
  iconPrimary: colorStr,
  iconPrimaryHover: colorStr,
  iconPrimaryPressed: colorStr,
  iconPrimaryHighContrast: colorStr,
  iconPrimaryHighContrastHover: colorStr,
  iconPrimaryHighContrastPressed: colorStr,
  iconPrimaryLowContrast: colorStr,
  iconPrimaryLowContrastHover: colorStr,
  iconPrimaryLowContrastPressed: colorStr,
  iconSecondary: colorStr,
  iconSecondaryHover: colorStr,
  iconSecondaryPressed: colorStr,
  iconSecondaryHighContrast: colorStr,
  iconSecondaryHighContrastHover: colorStr,
  iconSecondaryHighContrastPressed: colorStr,
  iconSecondaryLowContrast: colorStr,
  iconSecondaryLowContrastHover: colorStr,
  iconSecondaryLowContrastPressed: colorStr,
  iconPositive: colorStr,
  iconPositiveHover: colorStr,
  iconPositivePressed: colorStr,
  iconPositiveHighContrast: colorStr,
  iconPositiveHighContrastHover: colorStr,
  iconPositiveHighContrastPressed: colorStr,
  iconPositiveLowContrast: colorStr,
  iconPositiveLowContrastHover: colorStr,
  iconPositiveLowContrastPressed: colorStr,
  iconWarning: colorStr,
  iconWarningHover: colorStr,
  iconWarningPressed: colorStr,
  iconWarningHighContrast: colorStr,
  iconWarningHighContrastHover: colorStr,
  iconWarningHighContrastPressed: colorStr,
  iconWarningLowContrast: colorStr,
  iconWarningLowContrastHover: colorStr,
  iconWarningLowContrastPressed: colorStr,
  iconNegative: colorStr,
  iconNegativeHover: colorStr,
  iconNegativePressed: colorStr,
  iconNegativeHighContrast: colorStr,
  iconNegativeHighContrastHover: colorStr,
  iconNegativeHighContrastPressed: colorStr,
  iconNegativeLowContrast: colorStr,
  iconNegativeLowContrastHover: colorStr,
  iconNegativeLowContrastPressed: colorStr,
  iconMagic: colorStr,
  iconMagicHover: colorStr,
  iconMagicPressed: colorStr,
  iconMagicHighContrast: colorStr,
  iconMagicHighContrastHover: colorStr,
  iconMagicHighContrastPressed: colorStr,
  iconMagicLowContrast: colorStr,
  iconMagicLowContrastHover: colorStr,
  iconMagicLowContrastPressed: colorStr,
  iconInverted: colorStr,
  iconInvertedHover: colorStr,
  iconInvertedPressed: colorStr,
  ratingBorder: colorStr,
  ratingHover: colorStr,
  ratingPressed: colorStr,
  ratingInactive: colorStr,
  ratingSelected: colorStr,
  ratingFocus: colorStr,
  textInactive: colorStr,
  textInverted: colorStr,
  textOnAction: colorStr,
  textPrimary: colorStr,
  textPrimaryHover: colorStr,
  textPrimaryPressed: colorStr,
  textPrimaryStark: colorStr,
  textPrimaryStarkHover: colorStr,
  textPrimaryStarkPressed: colorStr,
  textSecondary: colorStr,
  textSecondaryHover: colorStr,
  textSecondaryPressed: colorStr,
  textSecondaryStark: colorStr,
  textSecondaryStarkHover: colorStr,
  textSecondaryStarkPressed: colorStr,
  textPositive: colorStr,
  textPositiveHover: colorStr,
  textPositivePressed: colorStr,
  textPositiveStark: colorStr,
  textPositiveStarkHover: colorStr,
  textPositiveStarkPressed: colorStr,
  textWarning: colorStr,
  textWarningHover: colorStr,
  textWarningPressed: colorStr,
  textWarningStark: colorStr,
  textWarningStarkHover: colorStr,
  textWarningStarkPressed: colorStr,
  textNegative: colorStr,
  textNegativeHover: colorStr,
  textNegativePressed: colorStr,
  textNegativeStark: colorStr,
  textNegativeStarkHover: colorStr,
  textNegativeStarkPressed: colorStr,
  textMagic: colorStr,
  textMagicHover: colorStr,
  textMagicPressed: colorStr,
  textMagicStark: colorStr,
  textMagicStarkHover: colorStr,
  textMagicStarkPressed: colorStr,
  gradientMagicPrimary: gradientArr,
  gradientMagicPrimaryDark: gradientArr,
  gradientNegativeMagic: gradientArr,
  gradientPrimaryPositive: gradientArr,
  gradientWarningNegative: gradientArr,
  gradientPositive: gradientArr,
  gradientPrimary: gradientArr
});